import {
  Avatar,
  Card,
  Checkbox,
  Col,
  ConfigProvider,
  Divider,
  Row,
  Space,
  Table,
  Tag,
  Typography,
} from "antd";
import React, { useState, useEffect } from "react";
import Text from "../../../../components/Text/Text";
import dayjs from "dayjs";
import { FlexCol, FlexRow } from "../../../../components/Container/Container";
import { numberFormatter } from "../../../../utility/Formatter";
import color from "../../../../resource/color";
import image from "../../../../resource/image";
import { DetailDuplicateModal } from "../../CODiscountComponent";

export const CODiscountStepThree: React.FC<{ form1: any; form2: any; typeList: any }> = ({
  form1,
  form2,
  typeList,
}) => {
  const dataForm1 = form1.getFieldsValue(true);
  const dataForm2 = form2.getFieldsValue(true);
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const [modalDuplicate, setModalDuplicate] = useState<any>({ data: undefined, open: false });

  const CardInfo = () => {
    const dataRender = [
      { name: "ชื่อรายการ", value: dataForm1?.name },
      {
        name: "ช่วงเวลา",
        value: `${dayjs(dataForm1?.startDate).format("DD/MM/YYYY")}, ${dayjs(dataForm1?.startTime).format("HH:mm")} - ${dayjs(dataForm1?.endDate).format("DD/MM/YYYY")}, ${dayjs(dataForm1?.endTime).format("HH:mm")}`,
      },
      { name: "สถานะส่วนลด", value: dataForm1?.status ? "เปิดใช้งาน" : "ปิดใช้งาน" },
      {
        name: "ประเภทส่วนลด",
        value: typeList.find((x) => x.creditMemoTypeId === dataForm1?.creditMemoTypeId),
      },
      {
        name: "วิธีคิดส่วนลด",
        value: dataForm1?.type === "BILL_PCT" ? "% ของยอดบิล" : "บาท (฿)/หน่วย",
      },
      {
        name: "แสดงให้ Dealer เห็นใน Shop",
        value: dataForm1?.visibleToDealer ? "แสดง" : "ไม่แสดง",
      },
    ];

    return (
      <>
        <Row justify={"space-between"} gutter={16}>
          <Col span={12}>
            {dataRender.slice(0, 3).map((item, index) => (
              <>
                <Card key={index} bodyStyle={{ padding: 12, backgroundColor: "#F3F6F9" }}>
                  <Text color='Text3'>{item.name}</Text>
                  <br />
                  <Text>{item.value}</Text>
                </Card>
                <br />
              </>
            ))}
          </Col>
          <Col span={12}>
            {dataRender.slice(3).map((item, index) => (
              <>
                <Card key={index} bodyStyle={{ padding: 12, backgroundColor: "#F3F6F9" }}>
                  <Text color='Text3'>{item.name}</Text>
                  <br />
                  {item.name.includes("ประเภทส่วนลด") ? (
                    <Tag
                      style={{
                        backgroundColor: `${item?.value?.color}20`,
                        border: "none",
                      }}
                    >
                      <Typography.Text
                        style={{
                          color: item?.value?.color,
                          fontFamily: "IBM Plex Sans Thai",
                          fontSize: 15,
                          fontWeight: "bold",
                        }}
                      >
                        {item?.value?.code} • {item?.value?.nameTh}
                      </Typography.Text>
                    </Tag>
                  ) : (
                    <Text>{item.value}</Text>
                  )}
                </Card>
                <br />
              </>
            ))}
          </Col>
        </Row>
      </>
    );
  };

  const columnProduct = [
    {
      title: "ชื่อสินค้า",
      dataIndex: "productName",
      key: "productName",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexRow align='center'>
              <div style={{ marginRight: 16 }}>
                <Avatar
                  src={
                    row.productImage === "No" ||
                    row.productImage === "" ||
                    row.productImage === null
                      ? image.product_no_image
                      : row.productImage
                  }
                  size={50}
                  shape='square'
                  onError={() => false}
                />
              </div>
              <FlexCol>
                <div style={{ height: 25, textOverflow: "ellipsis" }}>
                  <Text level={5}>{row.productName}</Text>
                </div>
                {row.commonName && (
                  <div style={{ height: 25, textOverflow: "ellipsis" }}>
                    <Text level={6} style={{ color: color.Grey }}>
                      {row.commonName}
                    </Text>
                  </div>
                )}
                <div style={{ height: 25 }}>
                  <Text level={6} style={{ color: color.Grey }}>
                    Product Group : {row.productGroup}
                  </Text>
                </div>
                {row.productStrategy && (
                  <div style={{ height: 25 }}>
                    <Text level={6} style={{ color: color.Grey }}>
                      Strategy Group : {row.productStrategy}
                    </Text>
                  </div>
                )}
              </FlexCol>
            </FlexRow>
          ),
        };
      },
    },
    {
      title: "Product Code",
      dataIndex: "productCodeNAV",
      key: "productCodeNAV",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexRow>
              <FlexCol>
                <div style={{ height: 25 }}>
                  <Text level={5}>{value}</Text>
                </div>
                <div style={{ height: 25, overflow: "hidden", textOverflow: "ellipsis" }}>
                  <Text level={6} style={{ color: color.Grey }}>
                    Pack Size : {row.packSize}
                  </Text>
                </div>
              </FlexCol>
            </FlexRow>
          ),
        };
      },
    },
    {
      title: "ราคาขาย",
      dataIndex: "marketPrice",
      key: "marketPrice",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexRow>
              <FlexCol>
                <div style={{ height: 25, overflow: "hidden", textOverflow: "ellipsis" }}>
                  <Text level={5}>
                    {numberFormatter(row.marketPrice)} บาท/{row.saleUOMTH}
                  </Text>
                </div>
                {profile.company === "ICPL" && (
                  <div style={{ height: 25 }}>
                    <Text level={6} style={{ color: color.Grey }}>
                      ราคา/หน่วย : <br />
                      {numberFormatter(value)} บาท/{row.baseUOM}
                    </Text>
                  </div>
                )}
              </FlexCol>
            </FlexRow>
          ),
        };
      },
    },
    {
      title: "ส่วนลด (บาท)",
      dataIndex: "discountValue",
      key: "discountValue",
      width: "20%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>
                {numberFormatter(value)}{" "}
                {row.discountMode === "PCT_PER_UNIT" ? "%/หน่วย" : "฿/หน่วย"}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
  ];

  const columnShop = [
    {
      title: "ร้านค้า",
      dataIndex: "customerName",
      key: "customerName",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value}</Text>
              <Text color='Text3' level={6}>
                {row.customerNo} • เขต {row.zone} • กลุ่ม {row.customerGroupName || "-"}
              </Text>
              {row.isDuplicate && (
                <Row>
                  <Text level={6} color={row?.isSwitchDisabled ? "error" : "warning"}>
                    {row?.isSwitchDisabled
                      ? "ร้านค้ากำลังใช้งานส่วนลดอื่นอยู่"
                      : "ร้านนี้มีสินค้าที่ซ้ำกับส่วนลดอื่น"}
                  </Text>
                  &nbsp;&nbsp;
                  <Text
                    level={6}
                    color={row?.isSwitchDisabled ? "error" : "warning"}
                    style={{ cursor: "pointer" }}
                    onClick={() => setModalDuplicate({ data: row.coDuplicateList, open: true })}
                  >
                    <u>ดูเพิ่มเติม</u>
                  </Text>
                </Row>
              )}
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Tag
                style={{
                  backgroundColor: value ? `${color.EmeraldGreen}10` : `${color.Disable}10`,
                  border: "none",
                }}
              >
                <Text color={value ? "EmeraldGreen" : "Disable"} fontWeight={600} level={6}>
                  {value ? "เปิดใช้งาน" : "ปิดใช้งาน"}
                </Text>
              </Tag>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "หมายเหตุถึง Sale",
      dataIndex: "latestSaleRemarkText",
      key: "latestSaleRemarkText",
      width: "15%",
      hidden: form1.getFieldValue("coId") ? false : true,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value || "-"}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "หมายเหตุถึง Dealer",
      dataIndex: "latestDealerRemarkText",
      key: "latestDealerRemarkText",
      width: "15%",
      hidden: form1.getFieldValue("coId") ? false : true,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value || "-"}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "% ของยอดบิล",
      dataIndex: "discountPct",
      key: "discountPct",
      width: "12%",
      hidden: dataForm1?.type === "BILL_PCT" ? false : true,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol style={{ alignItems: "center" }}>
              <Text>{numberFormatter(value)} %</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ส่วนลด (บาท)",
      dataIndex: "quotaAmount",
      key: "quotaAmount",
      width: "12%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol style={{ alignItems: "flex-end", paddingRight: 20 }}>
              <Text>{numberFormatter(value)} ฿</Text>
            </FlexCol>
          ),
        };
      },
    },
  ];

  return (
    <>
      <div style={{ paddingBottom: "10px" }}>
        <span
          className='card-label font-weight-bolder text-dark'
          style={{ fontSize: 20, fontWeight: "bold" }}
        >
          ตรวจสอบข้อมูล
        </span>
      </div>
      <CardInfo />
      {dataForm2?.products?.length > 0 && (
        <>
          <Divider size='small' />
          <div style={{ paddingBottom: "10px" }}>
            <span
              className='card-label font-weight-bolder text-dark'
              style={{ fontSize: 16, fontWeight: "bold" }}
            >
              {`สินค้า / สูตร (${dataForm2?.products?.length} รายการ)`}
            </span>
          </div>{" "}
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: "#F3F6F9",
                  fontFamily: "IBM Plex Sans Thai",
                  fontSize: 15,
                  rowHoverBg: "none",
                },
              },
            }}
          >
            <Table
              dataSource={dataForm2.products || []}
              columns={columnProduct}
              size='small'
              pagination={false}
              scroll={{ x: "max-content", y: 400 }}
            />
          </ConfigProvider>
        </>
      )}
      <Divider />
      <div style={{ paddingBottom: "10px" }}>
        <span
          className='card-label font-weight-bolder text-dark'
          style={{ fontSize: 16, fontWeight: "bold" }}
        >
          {`ร้านค้า + ส่วนลด (${dataForm2?.shops?.length} ร้านค้า`}
          {dataForm2?.shops?.filter((s) => s.status).length > 0 &&
            ` • เปิดใช้ ${dataForm2?.shops?.filter((s) => s.status).length} ร้าน)`}
        </span>
      </div>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#F3F6F9",
              fontFamily: "IBM Plex Sans Thai",
              fontSize: 15,
              rowHoverBg: "none",
            },
          },
        }}
      >
        <Table
          dataSource={dataForm2.shops || []}
          columns={columnShop}
          size='small'
          pagination={false}
          scroll={{ x: "max-content", y: 400 }}
          footer={() => (
            <Row justify={"start"} gutter={8}>
              <Col span={20}></Col>
              <Col span={4}>
                <Text color='primary' fontWeight={600}>
                  รวม{" "}
                  {numberFormatter(
                    dataForm2?.shops?.reduce(
                      (acc: number, shop: any) => acc + (Number(shop.quotaAmount) || 0),
                      0,
                    ),
                  )}{" "}
                  ฿
                </Text>
              </Col>
            </Row>
          )}
        />
      </ConfigProvider>
      {modalDuplicate.open && (
        <DetailDuplicateModal
          dataDup={modalDuplicate.data}
          open={modalDuplicate.open}
          setOpen={(open: boolean) => setModalDuplicate({ ...modalDuplicate, open })}
        />
      )}
    </>
  );
};
